module.exports = __webpack_public_path__ + "img/full4-min.c107b9e5.png";